import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useIsAuthenticated } from '@/features/auth/use-auth';

/**
 * Route guard for authenticated areas.
 *
 * Unauthenticated visitors are bounced to /login, preserving the originally
 * requested path so we can redirect back after sign-in.
 */
export const ProtectedRoute = (): React.JSX.Element => {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
};
